import { render, staticRenderFns } from "./ExternalWalletDetailPage.vue?vue&type=template&id=3f9e643c&"
import script from "./ExternalWalletDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalWalletDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports